import React, { Fragment } from 'react';

const About = () => {
  return (
    <div>
      <h1>About this App</h1>
      <p>App to Search GITHUB Users</p>
      <p>Version 1.0.0</p>
      <p>Developed and Maintained by charan kumar</p>
    </div>
  );
};

export default About;
